import { titleDecoder } from "@lib/sharedUtils";
import styles from "./style.module.scss";
import { GQLPosts, GQLOffers } from "@gql/types/gql";
import { useQuery } from "@tanstack/react-query";
import { TranslationsObject } from "@genericTypes/sharedTypes";
import { translate } from "@helpers/translationObjectFormatter";

export default function AuthorInfo({
    mainInfo,
    withBio,
    category,
    region,
    offer = false,
}: {
    mainInfo: GQLPosts | GQLOffers;
    withBio?: boolean;
    category?: string;
    region?: string;
    offer?: boolean;
}) {
    const { data: translations } = useQuery<TranslationsObject>([
        "translations",
    ]);
    const showEditor =
        mainInfo?.editorUser?.nickname &&
        mainInfo?.editorUser?.nickname !== mainInfo.writerUser?.nickname;
    return (
        <div
            className={withBio ? styles["authorContainerWithBio"] : ""}
            itemScope
            itemProp={offer ? "offeredBy" : "author"}
            itemType="https://schema.org/Person"
        >
            {!withBio && (
                <div className={`text-sm ${offer ? "mt-3" : ""}`}>
                    <span itemProp="name">
                        {translate(
                            translations,
                            "several_writersPage_writtenBy",
                        )}{" "}
                        :{" "}
                    </span>
                    <span itemProp="url">
                        <a
                            href={`/writers/${
                                mainInfo.writerUser?.nicknameSlug as string
                            }`}
                        >
                            {mainInfo.writerUser?.nickname}
                        </a>
                    </span>{" "}
                    {showEditor && (
                        <span>
                            <span className="hidden lg:inline">/ </span>
                            <span className="block lg:inline">
                                <span>
                                    {translate(
                                        translations,
                                        "several_writersPage_editedBy",
                                    )}{" "}
                                    :{" "}
                                </span>{" "}
                                <a
                                    href={`/writers/${
                                        mainInfo?.editorUser
                                            ?.nicknameSlug as string
                                    }`}
                                >
                                    {mainInfo.editorUser?.nickname}
                                </a>
                            </span>
                        </span>
                    )}
                </div>
            )}
            {withBio && (
                <>
                    <div className={styles["authorNameAndPosition"]}>
                        <span itemProp="name">
                            {translate(translations, "several_general-by-word")}{" "}
                            {mainInfo.writerUser?.nickname as string}
                        </span>
                        {mainInfo.writerUser?.position && (
                            <span itemProp="jobTitle">
                                {mainInfo.writerUser?.position}
                            </span>
                        )}
                    </div>

                    {mainInfo.writerUser?.bio && (
                        <span
                            itemProp="description"
                            className={styles["authorBio"]}
                            dangerouslySetInnerHTML={{
                                __html: titleDecoder(mainInfo.writerUser?.bio, {
                                    category: category ?? "",
                                    region: region ?? "",
                                }),
                            }}
                        />
                    )}
                    <span itemProp="url" className={styles["authorUrl"]}>
                        <a
                            href={`/writers/${
                                mainInfo.writerUser?.nicknameSlug as string
                            }`}
                        >
                            {translate(
                                translations,
                                "several_general-more-article",
                            )}{" "}
                            {mainInfo.writerUser?.nickname}
                        </a>
                    </span>
                </>
            )}
        </div>
    );
}
